import React, { useEffect, useState } from "react";
import API from "../API";
import SubordinatesList from "./SubordinatesList";
import OrganizationItem from "./OrganizationItem";
import AddOrganization from "./AddOrganization";
import Modal from "./Modal";
import { componentOpenAdd } from "./utils";
import './organizations.css';
import { ru } from "../data/ru";
import { by } from "../data/by";

export default function OrganizationsList() {
    const language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdOne : by.RoleIdOne;
    const api = new API();
    const [organizations, setOrganizations] = useState([]);
    const [idClickOrganization, setIdClickOrganization] = useState(localStorage.getItem("idO"));

    const buildHierarchy = (items, parentId = null, depth = 0) => {
        const result = [];

        for (const item of items) {
            if (item.parentId === parentId) {
                const children = buildHierarchy(items, item.idOrganization, depth + 1);
                if (children.length > 0) {
                    item.children = children;
                }
                result.push(item);
            }
        }

        return result;
    };

    const getOrganizationList = async () => {
        const isUserAdmin = localStorage.getItem('type') === 'Admin';

        try {
            const result = isUserAdmin
                ? await api.getOrganizations()
                : await api.getChildOrganizations(localStorage.getItem('idOrganization'));

            const arrOrganizations = isUserAdmin?buildHierarchy(result.organizations):result.organizations;
            setOrganizations(arrOrganizations);
        } catch (error) {
            console.error("Error fetching organization list:", error);
        }
    };

    useEffect(() => {
        getOrganizationList();
    }, []);

    const deleteItem = async (id) => {
        try {
            await api.deleteOrganization(id);
            const isUserAdmin = localStorage.getItem('type') === 'Admin';

            if(isUserAdmin){
                await getOrganizationList()
            }
            else {
                setOrganizations(prev => prev.filter(item => item.idOrganization !== id));
            }

        } catch (error) {
            console.error("Error deleting organization:", error);
        }
    };

    const clickHandlerOrganization = (id) => {
        setIdClickOrganization(id);
    };

    const renderOrganizationItem = (idOrganization, itemProps) => (
        <OrganizationItem
            key={idOrganization}
            idO={idOrganization}
            {...itemProps}
            onDelete={deleteItem}
            clickHandler={clickHandlerOrganization}
            setOrganization={getOrganizationList}
        />
    );

    const renderTableData = organizations.map(item => (
        <tr key={item.idOrganization}>
            <td>
                {document.body.clientWidth > 900
                    ? renderOrganizationItem(item.idOrganization, item)
                    : <Modal component={SubordinatesList} componentOpen={() => renderOrganizationItem(item.idOrganization, item,)} adaptive={true} />}
            </td>
        </tr>
    ));

    const subordinateJSX = idClickOrganization !== null && document.body.clientWidth > 900 ?
        <SubordinatesList id={idClickOrganization}/>:  null


    return (
        <div className='organization'>
            <div className="organization_panel">
                <h2>{language.subordinates}:</h2>
                <Modal additional={getOrganizationList} componentOpen={componentOpenAdd} component={AddOrganization} />
            </div>
            <table className="organization_table">
                <tbody>
                {renderTableData}
                </tbody>
            </table>
            {subordinateJSX}
        </div>
    );
}
